import * as React from 'react';
import TableContainer from '@mui/material/TableContainer';
import Paper from '@mui/material/Paper';
import {Button, Tooltip} from '@mui/material';
import pencilEditIcon from '../../Assets/images/pencilEditIcon.PNG'
import {Delete, Phone} from '@mui/icons-material';
import {COMPLETED_CALL, MISSED_CALL} from "../Utils/constants";

export default function SimpleTable(props) {
    const {
        rows,
        columnHeader,
        columnKeys,
        copyOption,
        beautify,
        editing,
        openModal,
        row,
        removeRow,
        statusKey,
        status,
        columnKeyIcons,
        handleActionCallback
    } = props;
    const [copyMessage, setCopyMessage] = React.useState("");
    const [data, setData] = React.useState([]);
    const tableRef = React.useRef(null);

    React.useEffect(() => {
        if (rows) {
            if (editing) {
                const _rows = rows.map(function (el) {
                    var o = Object.assign({}, el);
                    if (statusKey && status && el[statusKey] === status) {
                        o.actions = (
                            <div className="actions"></div>
                        )
                    } else {

                        o.actions = (
                            <div className="actions"
                                 style={{display: 'flex', alignItems: 'center', justifyContent: 'space-evenly'}}>
                                {
                                    editing.update && (
                                        <img onClick={() => handleRecordClick(el, 'update')} src={pencilEditIcon}
                                             style={{width: '22px', cursor: 'pointer'}}/>
                                    )
                                }
                                {
                                    editing.remove && (
                                        <>
                                            <Tooltip title={"Delete"}>
                                                <Delete color="error"
                                                        sx={{fontSize: '18px'}}
                                                        onClick={() => handleRecordClick(el, 'remove')}/>
                                            </Tooltip>
                                        </>
                                    )
                                }
                                {
                                    editing.completed && (
                                        <Tooltip title={"Completed call"}>
                                            <Phone sx={{color: 'green', fontSize: '18px'}}
                                                   onClick={() => handleRecordClick(el, COMPLETED_CALL)}/>
                                        </Tooltip>
                                    )
                                }
                                {
                                    editing.missed && (
                                        <Tooltip title={"Missed call"}>
                                            <Phone sx={{color: 'red', fontSize: '18px'}}
                                                   onClick={() => handleRecordClick(el, MISSED_CALL)}/>
                                        </Tooltip>
                                    )
                                }
                            </div>
                        );
                    }
                    return o;
                });
                setData(_rows)
            } else {
                setData(rows)
            }
        }
    }, [rows]);

    const handleRecordClick = (el, action) => {
        if (action === "update") {
            row(el);
            openModal(true)
        } else if (action === "remove") {
            removeRow(el);
        } else if (action === "missed_call" || action === "completed_call") {
            row(el);
            handleActionCallback(el, action);
        }
    }

    const copyToClipboard = (_e) => {
        var body = document.body, range, sel;
        if (document.createRange && window.getSelection) {
            range = document.createRange();
            sel = window.getSelection();
            sel.removeAllRanges();
            try {
                range.selectNodeContents(tableRef.current);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(tableRef.current);
                sel.addRange(range);
            }
        } else if (body.createTextRange) {
            range = body.createTextRange();
            range.moveToElementText(tableRef.current);
            range.select();
        }
        document.execCommand("Copy");
        setCopyMessage("Copied!");
    };

    return (
        <div style={{display: 'flex', alignItems: 'start'}}>
            <TableContainer ref={tableRef} component={Paper}>
                <table size="small" style={{width: '100%', borderCollapse: beautify ? 'collapse' : 'separate'}}>
                    {data.length > 0 && columnHeader && <thead>
                    <tr>
                        {
                            columnHeader.map((item) => <th style={{
                                border: !beautify ? "1px solid #8c8c8c" : "none",
                                borderBottom: beautify ? "0.5px solid #c2c2c2" : "1px solid #8c8c8c",
                                padding: !beautify ? "5px 10px" : "5px",
                                fontSize: "14px",
                                textAlign: 'left'
                            }}>{item}</th>)
                        }
                    </tr>
                    </thead>
                    }
                    <tbody>
                    {data.map((row) => (
                        <tr
                            key={row.name}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >
                            {
                                columnKeys.map(key => <td style={{
                                    border: !beautify ? "1px solid #8c8c8c" : "none",
                                    padding: beautify ? "5px" : "5px 10px",
                                    fontSize: beautify ? "13px" : "14px"
                                }}>{columnKeyIcons[key] && columnKeyIcons[key]['showOnTrue'] === true && row[key] === 1 ? columnKeyIcons[key]['icon'] : row[key] ? row[key] : "-"}</td>)
                            }
                        </tr>
                    ))}
                    </tbody>
                </table>
            </TableContainer>
            {data && data.length > 0 && copyOption && (
                <div style={{display: 'flex', flexDirection: "column"}}>
                    <div style={{margin: '0 0 0 10px'}}>
                        <Button color="inherit" variant="contained" onClick={copyToClipboard}>Copy</Button>
                    </div>
                    <div style={{color: "green", fontSize: '13px', textAlign: 'center', marginTop: "10px"}}>
                        {copyMessage}
                    </div>
                </div>
            )}
        </div>
    );
}
